import { Flex } from '@chakra-ui/react';
import React from 'react';
import dynamic from 'next/dynamic';
import useBlogData from './utils/useBlogData';
import Navigation from '@components/Shared/Navigation';
import { FeaturedPostDataFragment } from '@src/generated/graphql';
import { colorsGrey } from '@src/theme/chakraTheme/colors';
import SEO from '@components/SEO';
import { MAIN_URL } from '@src/commons/constants';
import {
  MAIN_BLOG_PAGE_DESC,
  MAIN_BLOG_PAGE_TITLE,
} from '@src/commons/seoConstants';

const DynamicBlogPostsList = dynamic(
  () => import('@components/Blog/BlogPostsList')
);
const DynamicPostSidebar = dynamic(
  () => import('@components/Post/PostSidebar')
);

const Blog: ComponentWithDataHooks = () => {
  const { categories, featuredPosts, tags, allPosts, mainImageUrl } =
    useBlogData();
  return (
    <Flex direction="column" bgColor={colorsGrey[50]}>
      <SEO
        title={MAIN_BLOG_PAGE_TITLE}
        description={MAIN_BLOG_PAGE_DESC}
        image={mainImageUrl}
        url={`${MAIN_URL}/blog`}
      />
      <Navigation />
      <Flex
        mt={['30px', null, '70px']}
        pt="42px"
        pb="50px"
        px="20px"
        direction={['column', null, 'row']}
        maxW={{ base: '960px', lg: '1180px' }}
        mx="auto"
      >
        <DynamicBlogPostsList posts={allPosts} />
        <DynamicPostSidebar
          tags={tags}
          categories={categories}
          featuredPosts={featuredPosts as FeaturedPostDataFragment[]}
        />
      </Flex>
    </Flex>
  );
};

Blog.dataHooks = [useBlogData];

export default Blog;
